/* eslint-disable import/default */
/* eslint-disable import/namespace */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useEffect, useContext, useState } from "react";
import ArcGISMap from "@arcgis/core/Map";
import MapView from "@arcgis/core/views/MapView";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";

import "./MapWrap.scss";
import { MapContext } from "../../context/MapContext";
import Header from "../Header/Header";
import SideNav from "../SideNav/SideNav";
import AppPanel from "../AppPanel/AppPanel";
import BasemapSelector from "../BasemapSelector/BasemapSelector";
import CompassWidget from "../CompassWidget/CompassWidget";
import ScaleBarWidget from "../ScaleBarWidget/ScaleBarWidget";
import { whenTrue } from "@arcgis/core/core/watchUtils";
import MapActions from "../MapActions/MapActions";
import MapLegend from "../MapLegend/MapLegend";
import useQueryString from "../../hooks/useQueryString";
import { clearQueryStrings } from "../../hooks/queryString";

import Alert from "calcite-react/Alert/Alert";

import MapConfig from "./MapConfig";
import utils from "../../helpers/utils";
import { StyledAlertMessage } from "calcite-react/Alert/Alert-styled";
import { LayoutContext } from "../../context/LayoutContext";
import { MobileHeader } from "../Header/MobileHeader";
import { Drawer, IconButton, makeStyles } from "@material-ui/core";
import { KeyboardArrowDown, KeyboardArrowUp } from "@material-ui/icons";
import MobileMapLegend from "../MapLegend/MobileMapLegend";

function MapWrap() {
  const mapDiv = useRef(null);
  const mouseOverHandle = useRef(null);
  // eslint-disable-next-line no-unused-vars
  const [mapObject, setMap] = useContext(MapContext);
  const [extentXMin, setExtentXmin] = useQueryString("xmin", -7643346.9186);
  const [extentYMin, setExtentYmin] = useQueryString("ymin", 1270287.8638);
  const [extentXMax, setExtentXmax] = useQueryString("xmax", -6077916.5793);
  const [extentYMax, setExtentYmax] = useQueryString("ymax", 2088469.8146);
  const [app, setApp] = useQueryString("app", "intro");
  const [basemap, setBasemap] = useQueryString("basemap", "streets-vector");

  const [basemapOpen, setBasemapOpen] = useState(false);
  const [measureToolOpen, setMeasureToolOpen] = useState(false);
  const [areaToolOpen, setAreaToolOpen] = useState(false);
  const [viewLegendOpen, setViewLegendOpen] = useState(false);

  const { mobileActive } = useContext(LayoutContext);

  const [disclaimerOpen, setDisclaimerOpen] = useState(false);
  const [appDrawerDir, setAppDrawerDir] = useState(false);
  const [appDrawerHalfOpen, setDrawerHalfOpen] = useState(true);

  const paths = [
    "intro",
    "coral-rec-tourism",
    "beach-rec-tourism",
    "rec-fishing",
    "coral-reef-fisheries",
    "wildlife-tourism",
  ];
  const hoverLayers = [
    "Birdwatching Hotspots",
  ];
  useEffect(() => {
    if (mapDiv.current) {
      const map = new ArcGISMap({
        basemap,
      });

      const view = new MapView({
        map,
        container: mapDiv.current,
        // maxScale: 20000, this ain't working
        extent: {
          spatialReference: {
            wkid: 3857,
          },
          xmin: extentXMin,
          ymin: extentYMin,
          xmax: extentXMax,
          ymax: extentYMax,
        },

        popup: {
          dockOptions: {
            buttonEnabled: false, //can't close hover popup if it's docked, removing option for user
            breakpoint: false,
          },
        },
      });

      // view.popup.watch("visible", function (status) {
      //   if (status) {
      //     // event is the event handle returned after the event fires.
      //     console.log(event.mapPoint);
      //   }
      // });

      view.watch("scale", function () {
        if (view.scale < 20000) {
          view.scale = 20000;
        }
      });

      // add eez layer for all apps (let apps tell layer what to show)
      const eezLayer = new FeatureLayer({
        url: MapConfig.rootURL + MapConfig.eezURL,
        title: "Exclusive Economic Zones (EEZ)",
        id: "eez",
        definitionExpression: "1=-1",
      });
      map.add(eezLayer);

      const esriObjs = {
        map,
        view,
      };

      // Watch view's stationary property for becoming true.
      whenTrue(view, "stationary", () => {
        // Get the new extent of the view only when view is stationary.
        if (view.extent) {
          setExtentInQS(view);
        }
      });

      setMap(esriObjs);
    }
  }, [setMap]);

  useEffect(() => {
    if (mapObject) {
      if (mouseOverHandle.current) {
        mouseOverHandle.current.remove();
      }
      mouseOverHandle.current = mapObject.view.on(
        "pointer-move",
        async (event) => {
          //ignore
          //if 1 of the layers is on that we care about, then perform this logic
          // this interferes with the search popup if allows to run at any time.
          const hitLayers = mapObject.map.layers.filter(
            (l) => l.visible && hoverLayers.includes(l.title)
          );

          if (
            hitLayers.length &&
            (!mapObject.view.popup.visible ||
              !utils.doesMouseIntersect(
                document.getElementsByClassName("esri-popup")[0],
                event.native.clientX,
                event.native.clientY
              ))
          ) {
            // added include to slightly reduce overhead
            mapObject.view
              .hitTest(event, { include: hitLayers })
              .then((response) => {
                if (response.results.length) {
                  const graphic = response.results.filter((result) => {
                    // check if the graphic belongs to the layer of interest
                    return hoverLayers.includes(result.graphic.layer.title);
                  })[0]?.graphic;
                  if (graphic) {
                    mapObject.view.popup.open({
                      location: graphic.geometry.centroid,
                      features: [graphic],
                    });
                  } else {
                    mapObject.view.popup.visible &&
                      mapObject.view.popup.close();
                  }
                } else {
                  mapObject.view.popup.visible && mapObject.view.popup.close();
                }
              });
          }
        }
      );
    }
    return () => {
      if (mouseOverHandle.current) {
        mouseOverHandle.current.remove();
      }
    };
  }, [mapObject?.view]);

  useEffect(() => {
    setTimeout(() => {
      //check browser storage and show disclaimer if needed
      setDisclaimerOpen(!window.localStorage.getItem("disclaimerDismissed"));
    }, 500);
  }, []);

  useEffect(() => {
    if (mobileActive && (app === "" || !app)) {
        clearQueryStrings();
        setApp("intro");
    }
  }, [mobileActive]);

  const dismissDisclaimer = () => {
    setDisclaimerOpen(false);
    window.localStorage.setItem("disclaimerDismissed", true);
  };

  const setExtentInQS = (view) => {
    setExtentXmin(view.extent.xmin.toFixed(2));
    setExtentYmin(view.extent.ymin.toFixed(2));
    setExtentXmax(view.extent.xmax.toFixed(2));
    setExtentYmax(view.extent.ymax.toFixed(2));
  };

  const toggleAppDrawer = () => {
    setDrawerHalfOpen(!appDrawerHalfOpen);
    setAppDrawerDir(appDrawerDir === appDrawerHalfOpen);
  }

  const closeAppDrawer = () => {
    setDrawerHalfOpen(false);
    setAppDrawerDir(false);
  }

  const useStyles = makeStyles((theme) => ({
    drawerOpen: {
      height: '100%',
      zIndex: 0,
      transition: theme.transitions.create('height', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      '&.half': {
        height: '50%',
      },
    },
    drawerClosed: {
      height: '24px',
      zIndex: 0,
      transition: theme.transitions.create('height', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      '&.half': {
        height: '50%',
      },
    },
    paper: {
      position: 'static',
      borderTop: 'none',
    }
  }));

  const classes = useStyles();

  return (
    <>
      {mobileActive
        ? <MobileHeader
            setDrawerHalfOpen={setDrawerHalfOpen}
            setAppDrawerDir={setAppDrawerDir}
            setBasemapOpen={setBasemapOpen}
            setViewLegendOpen={setViewLegendOpen}
            app={app}
            setApp={setApp}/>
        : <Header />}

      <div
        className={`disclaimer ${paths.includes(app) && !mobileActive ? "appIsActive" : ""
          } ${disclaimerOpen ? "active" : ""}`}
      >
        <Alert
          full
          showIcon
          closeLabel="Dismiss"
          showCloseLabel
          open={disclaimerOpen}
          onClose={dismissDisclaimer}
        >
          <StyledAlertMessage>
            The maps displayed on this site are for reference only. The
            boundaries, colors, denominations and any other information shown on
            these maps do not imply any judgment on the legal status of any
            territory, or any endorsement or acceptance of such boundaries.
          </StyledAlertMessage>
        </Alert>
      </div>

      <div
        className={
          `
            ${paths.includes(app)
            ? "bodyWrap appIsActive"
            : "bodyWrap"}
          `
        }
      >
        {!mobileActive && <SideNav app={app} setApp={setApp} />}
        {app && app !== "" && !mobileActive && (
          <AppPanel app={app} setApp={setApp} />
        )}
        <div className="mapDiv" ref={mapDiv}>
          <MapActions
            basemapOpen={basemapOpen}
            setBasemapOpen={setBasemapOpen}
            measureToolOpen={measureToolOpen}
            setMeasureToolOpen={setMeasureToolOpen}
            areaToolOpen={areaToolOpen}
            setAreaToolOpen={setAreaToolOpen}
            viewLegendOpen={viewLegendOpen}
            setViewLegendOpen={setViewLegendOpen}
            closeAppDrawer={mobileActive && closeAppDrawer}
          />
          <BasemapSelector
            basemapOpen={basemapOpen}
            setBasemapOpen={setBasemapOpen}
            setBasemap={setBasemap}
            measureToolOpen={measureToolOpen}
            setMeasureToolOpen={setMeasureToolOpen}
            areaToolOpen={areaToolOpen}
            setAreaToolOpen={setAreaToolOpen}
            viewLegendOpen={viewLegendOpen}
            setViewLegendOpen={setViewLegendOpen}
            closeAppDrawer={mobileActive && closeAppDrawer}
          />
          <div>
            {!mobileActive
              ? <MapLegend />
              : <MobileMapLegend
                appDrawerExtended={appDrawerDir && !appDrawerHalfOpen}
                viewLegendOpen={viewLegendOpen}
                setViewLegendOpen={setViewLegendOpen}
              />}
          </div>
          <CompassWidget />
          <ScaleBarWidget />
        </div>
        {app && app !== "" && mobileActive && (
          <>
            <Drawer
              variant="permanent"
              className={`${appDrawerDir ? classes.drawerOpen : classes.drawerClosed} ${appDrawerHalfOpen && 'half'}`}
              classes={{
                paper: classes.paper
              }}
              anchor="bottom"
            >
              <IconButton
                disableRipple
                onClick={toggleAppDrawer}
                
                style={{
                  borderRadius: '0',
                  color: "white",
                  backgroundColor: '#031D44',
                  padding: '0px',
                }}
              >
                {appDrawerDir === appDrawerHalfOpen ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
              </IconButton>
              <AppPanel app={app} setApp={setApp} />
            </Drawer>
          </>
        )}
      </div>
    </>
  );
}

export default MapWrap;
